import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Facebook, Instagram, Youtube, Linkedin, Twitter, Handshake } from "lucide-react";
import { Logo } from "./Logo";
import { useApply } from "@/context/ApplyContext";

const LEGAL = [
  ["About Us", "/about-us"], ["Contact Us", "/contact-us"], ["Grievance Redressal", "/grievance-redressal"],
  ["Lending Partners & APR", "/lending-partners"], ["No Fee Policy", "/no-fee-policy"], ["Fair Practices Code", "/fair-practices-code"],
  ["Privacy Policy", "/privacy-policy"], ["Terms & Conditions", "/terms"], ["Disclaimer", "/disclaimer"],
  ["Cookie Policy", "/cookie-policy"], ["Data Deletion", "/data-deletion"], ["DSA / Partner Terms", "/partner-terms"],
];
const SOCIAL = [["facebook", Facebook], ["instagram", Instagram], ["youtube", Youtube], ["linkedin", Linkedin], ["x", Twitter]];

const Col = ({ title, children }) => (
  <div>
    <h3 className="text-sm font-bold uppercase tracking-[0.14em] !text-white/60 !tracking-[0.14em] mb-4">{title}</h3>
    <ul className="space-y-2.5 text-[15px]">{children}</ul>
  </div>
);

export const Footer = ({ settings }) => {
  const { goTo, openApply } = useApply();
  const c = settings?.company || {};
  const social = settings?.social || {};
  const link = "text-white/80 hover:text-[var(--pp-cta)] transition-colors";
  return (
    <footer className="bg-[var(--pp-night)] text-white" data-testid="site-footer">
      <div className="pp-container py-14 grid gap-10 md:grid-cols-2 lg:grid-cols-[1.3fr_0.9fr_1.6fr_0.9fr]">
        <div className="space-y-4">
          <Logo dark testId="footer-logo" />
          <p className="text-white/70 text-[15px] max-w-sm">A free loan marketplace connecting you with RBI-regulated banks and NBFCs.</p>
          <address className="not-italic space-y-2 text-[15px] text-white/80" data-testid="footer-company-details">
            <p className="font-semibold text-white">{c.name}</p>
            <p className="flex gap-2"><MapPin size={16} className="mt-1 shrink-0" />{c.address}</p>
            <p className="flex gap-2"><Phone size={16} className="mt-1 shrink-0" />{c.phone}</p>
            <p className="flex gap-2"><Mail size={16} className="mt-1 shrink-0" />{c.email}</p>
          </address>
        </div>
        <Col title="Quick links">
          <li><Link to="/" className={link} data-testid="footer-link-home">Home</Link></li>
          <li><Link to="/loans" className={link} data-testid="footer-link-loans">Loans</Link></li>
          <li><Link to="/calculators" className={link} data-testid="footer-link-calculators">Calculators</Link></li>
          <li><Link to="/blog" className={link} data-testid="footer-link-blog">Blog</Link></li>
          <li><button type="button" onClick={() => openApply()} className={link} data-testid="footer-link-apply">Apply For Loan</button></li>
          <li><button type="button" onClick={() => goTo("own-brand-agency")} className={link} data-testid="footer-link-agency">Own Brand Loan Agency</button></li>
          <li><Link to="/lenders-collaboration" className="inline-flex items-center gap-1.5 rounded-full bg-[var(--pp-cta)] text-[var(--pp-night)] font-bold px-3.5 py-1.5 text-sm hover:brightness-95 transition-[filter]" data-testid="footer-link-lenders-collab"><Handshake size={15} /> Lenders Collaboration</Link></li>
        </Col>
        <Col title="Legal & Trust">
          <li className="grid grid-cols-2 gap-x-4 gap-y-2.5">
            {LEGAL.map(([l, to]) => <Link key={to} to={to} className={link} data-testid={`footer-legal-${to.slice(1)}`}>{l}</Link>)}
            <button type="button" onClick={() => window.dispatchEvent(new Event("pp:cookie-settings"))} className={`${link} text-left`} data-testid="footer-cookie-settings">Cookie settings</button>
          </li>
        </Col>
        <Col title="Follow us">
          <li className="flex gap-3 flex-wrap">
            {SOCIAL.map(([k, I]) => (
              <a key={k} href={social[k] || "#"} target="_blank" rel="noopener noreferrer" aria-label={k} data-testid={`footer-social-${k}`}
                className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center hover:bg-[var(--pp-cta)] hover:text-[var(--pp-night)] transition-colors">
                <I size={18} />
              </a>
            ))}
          </li>
        </Col>
      </div>
      <div className="border-t border-white/10">
        <div className="pp-container py-6 space-y-3 text-[13px] text-white/60">
          <p data-testid="footer-disclaimer"><strong className="text-white/80">Marketplace disclaimer:</strong> {settings?.disclaimer}</p>
          <p data-testid="footer-legal-entity">{c.brand || "Paisapaid Loans"} is operated by {settings?.legal?.legal_name} · CIN: {settings?.legal?.cin} · Registered office: {settings?.legal?.registered_address || c.address}</p>
          <p>© 2014 {c.brand || "Paisapaid Loans"}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
